var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessWhiteR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 647 823",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-179,-83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_whiteR",
    d: "M202,136L202,444C202,444 200.52,478.396 250,480C299.48,481.604 339,480 339,480L339,765L268,765C206.784,764.469 202.978,881.896 271,882.438C335.393,882.951 699.421,883.351 749,882.438C804.578,881.414 796.655,765.927 744,765C689.346,764.038 670,765 670,765L670,480C670,480 732.776,480.277 763,480C803.266,479.631 802.709,468.131 802,446C801.356,425.878 802,136 802,136C801.934,116.847 803.382,106.264 737,105.998C671.457,105.736 670.506,113.15 670,136C669.494,158.85 670,274 670,274L572,270L572,136C572.547,114.752 572.944,105.081 500,105.998C432.928,106.841 435.748,113.407 435,136C434.186,160.611 435,270 435,270L339,271L339,136C337.492,110.729 338.84,105.526 273,105.998C199.375,106.526 201.902,112.952 202,136Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "45.83px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessWhiteR);
export default __webpack_public_path__ + "static/media/chess_whiteR.8ed970caea00b3674768ae0e9d06bb59.svg";
export { ForwardRef as ReactComponent };